module.exports = __webpack_public_path__ + "img/pic_number_80_black.954cf31c.png";